import CredentialsDialogContents from './CredentialsDialogContents';

export default CredentialsDialogContents;
